<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="homesection" v-visible="show">
      <div class="SliderFrame">
        <div class="sideMenu">
          <label for="sideMenu-active" @click="openSiderMenu">
            More Exhibitors
          </label>

          <div class="sidemenu p-4">
            <p>&nbsp;</p>

            <div class="fixed-top bg-secondary text-white">
              <div class="PcDevice">
                <h5 class="m-3 ml-4">
                  <div v-if="prevRoute == 'AdvanceSearchExhibitors'" style="font-size:18px">
                    <i class="fas fa-caret-down"></i>
                    <span> Advanced Search Exhibitors</span>
                  </div>

                  <div v-else-if="prevRoute == 'BrowsingHistoryExhibitors'" style="font-size:18px">
                    <i class="fas fa-caret-down"></i>
                    <span> Browsing History Exhibitors</span>
                  </div>

                  <div v-else-if="prevRoute == 'FavoriteExhibitors'">
                    <i class="fas fa-caret-down"></i>
                    <span> Favorite Exhibitors</span>
                  </div>

                  <div v-else>
                    <i class="fas fa-caret-down"></i>
                    <span> More Exhibitors</span>
                  </div>
                </h5>
              </div>
              <div class="MbDevice">
                <div style="font-size:18px">
                  <div class="m-3 ml-4 font-weight-bold" v-if="prevRoute == 'AdvanceSearchExhibitors'">
                    <i class="fas fa-caret-down"></i>
                    <span> Advanced Search Exhibitors</span>
                  </div>

                  <div class="m-3 ml-4 font-weight-bold" v-else-if="prevRoute == 'BrowsingHistoryExhibitors'">
                    <i class="fas fa-caret-down"></i>
                    <span> Browsing History Exhibitors</span>
                  </div>

                  <div class="m-3 ml-4 font-weight-bold" v-else-if="prevRoute == 'FavoriteExhibitors'">
                    <i class="fas fa-caret-down"></i>
                    <span> Favorite Exhibitors</span>
                  </div>

                  <div class="m-3 ml-4 font-weight-bold" v-else>
                    <i class="fas fa-caret-down"></i>
                    <span> More Exhibitors</span>
                  </div>
                </div>
              </div>
            </div>

            <p>&nbsp;</p>

            <div style="margin-top:60px">
              <div v-for="(item, index) in InterestExhibList" :key="index">
                <div
                  class="d-flex my-4 "
                  @click.prevent="goExhDetail(item.RegNo)"
                  :class="{ PickedExh: currentExh == item.ComName }"
                  style="font-size:14px"
                  id="closeSidebar"
                >
                  <p class="mr-2 ExhHover">{{ index + 1 }}.</p>
                  <p class="ExhHover">{{ item.ComName }}</p>
                </div>
              </div>
            </div>

            <p>&nbsp;</p>
            <router-link :to="`/Exhibitors/Page=${1}`">
              <div class="ml-4">
                <div class="btn btn-primary px-3">Advanced Search</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- 攤位主題 -->

      <div class="PcDevice">
        <div class="container ">
          <div class="row justify-content-center">
            <p>&zwnj;</p>
            <div class="ExhType mt-5">
              <div class="A1" v-show="Booth_Design == 'A1'">
                <img src="../../assets/images/Expo_Topic1.png" width="1200px" class="rounded" />

                <div class="A1_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="TopicA1_Banner01  BannerHover img-thumbnailA1 "
                      @click="Savelog_Banner1()"
                    />
                    <span class="TopicA1_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="TopicA1_Banner02 BannerHover img-thumbnailA1"
                      @click="Savelog_Banner2()"
                    />
                    <span class="TopicA1_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicA1_Video BannerHover "
                    />

                    <span class="TopicA1_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicA1_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="150px"
                        height="90px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicA1_dotVideoYouku"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicA1_Video BannerHover "
                    />

                    <span class="TopicA1_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicA1_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicA1_staffArea "></div>
                </span>
              </div>

              <div class="A2" v-show="Booth_Design == 'A2'">
                <img src="../../assets/images/Expo_Topic2.png" width="1200px" class="rounded" />

                <div class="A2_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="TopicA2_Banner01  BannerHover " @click="Savelog_Banner1()" />
                    <span class="TopicA2_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="TopicA2_Banner02 BannerHover" @click="Savelog_Banner2()" />
                    <span class="TopicA2_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicA2_Video BannerHover "
                    />

                    <span class="TopicA2_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicA2_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="141px"
                        height="83px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicA2_dotVideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicA2_Video BannerHover "
                    />

                    <span class="TopicA2_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicA2_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicA2_staffArea "></div>
                </span>
              </div>

              <div class="A3" v-show="Booth_Design == 'A3'">
                <img src="../../assets/images/Expo_TopicA3.png" width="1200px" class="rounded" />

                <div class="A3_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="TopicA3_Banner01  BannerHover " @click="Savelog_Banner1()" />
                    <span class="TopicA3_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="TopicA3_Banner02 BannerHover" @click="Savelog_Banner2()" />
                    <span class="TopicA3_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicA3_Video BannerHover "
                    />

                    <span class="TopicA3_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicA3_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="149px"
                        height="90px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicA3_dotVideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicA3_Video BannerHover "
                    />

                    <span class="TopicA3_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicA3_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicA3_staffArea "></div>
                </span>
              </div>

              <div class="A4" v-show="Booth_Design == 'A4'">
                <img src="../../assets/images/Expo_TopicA4.png" width="1200px" class="rounded" />

                <div class="A4_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="TopicA4_Banner01  BannerHover " @click="Savelog_Banner1()" />
                    <span class="TopicA4_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="TopicA4_Banner02 BannerHover" @click="Savelog_Banner2()" />
                    <span class="TopicA4_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicA4_Video BannerHover "
                    />

                    <span class="TopicA4_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicA4_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="154px"
                        height="103px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicA4_dotVideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicA4_Video BannerHover "
                    />

                    <span class="TopicA4_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicA4_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicA4_staffArea "></div>
                </span>
              </div>

              <div class="A5" v-show="Booth_Design == 'A5'">
                <img src="../../assets/images/Expo_TopicA5.png" width="1200px" class="rounded" />

                <div class="A5_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="TopicA5_Banner01  BannerHover " @click="Savelog_Banner1()" />
                    <span class="TopicA5_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="TopicA5_Banner02 BannerHover" @click="Savelog_Banner2()" />
                    <span class="TopicA5_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicA5_Video BannerHover "
                    />

                    <span class="TopicA5_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicA5_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="154px"
                        height="103px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicA5_dotVideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicA5_Video BannerHover "
                    />

                    <span class="TopicA5_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicA5_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicA5_staffArea "></div>
                </span>
              </div>

              <div class="A6" v-show="Booth_Design == 'A6'">
                <img src="../../assets/images/Expo_TopicA6.png" width="1200px" class="rounded" />

                <div class="A6_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="TopicA6_Banner01  BannerHover " @click="Savelog_Banner1()" />
                    <span class="TopicA6_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="TopicA6_Banner02 BannerHover" @click="Savelog_Banner2()" />
                    <span class="TopicA6_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicA6_Video BannerHover "
                    />

                    <span class="TopicA6_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicA6_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="154px"
                        height="103px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicA6_dotVideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicA6_Video BannerHover "
                    />

                    <span class="TopicA6_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicA6_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicA6_staffArea "></div>
                </span>
              </div>

              <div class="B1 " v-show="Booth_Design == 'B1'">
                <img src="../../assets/images/Expo_Topic3.png" width="1200px" class="rounded" />

                <div class="B1_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>
                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="TopicB1_Banner01  BannerHover " @click="Savelog_Banner1()" />
                    <span class="TopicB1_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="TopicB1_Banner02 BannerHover" @click="Savelog_Banner2()" />
                    <span class="TopicB1_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img :src="ExpoM_Banner3" class="TopicB1_Banner03 BannerHover" @click="Savelog_Banner3()" />
                    <span class="TopicB1_dot3"><i class="far fa-dot-circle"></i></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img :src="ExpoM_Banner4" class="TopicB1_Banner04 BannerHover" @click="Savelog_Banner4()" />
                    <span class="TopicB1_dot4"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicB1_Video BannerHover "
                    />

                    <span class="TopicB1_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicB1_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="177px"
                        height="105px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicB1_dotVideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicB1_Video BannerHover "
                    />

                    <span class="TopicB1_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicB1_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicB1_staffArea "></div>
                </span>
              </div>

              <div class="B2 " v-show="Booth_Design == 'B2'">
                <img src="../../assets/images/Expo_Topic4.png" width="1200px" class="rounded" />

                <div class="B2_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="TopicB2_Banner01  BannerHover img-thumbnailB2 "
                      @click="Savelog_Banner1()"
                    />
                    <span class="TopicB2_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="TopicB2_Banner02 BannerHover img-thumbnailB2"
                      @click="Savelog_Banner2()"
                    />
                    <span class="TopicB2_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="TopicB2_Banner03 BannerHover img-thumbnailB2"
                      @click="Savelog_Banner3()"
                    />
                    <span class="TopicB2_dot3"><i class="far fa-dot-circle"></i></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="TopicB2_Banner04 BannerHover img-thumbnailB2"
                      @click="Savelog_Banner4()"
                    />
                    <span class="TopicB2_dot4"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicB2_Video BannerHover "
                    />

                    <span class="TopicB2_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicB2_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="149px"
                        height="88px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicB2_dotVideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicB2_Video BannerHover "
                    />

                    <span class="TopicB2_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicB2_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicB2_staffArea "></div>
                </span>
              </div>

              <div class="B3" v-show="Booth_Design == 'B3'">
                <img src="../../assets/images/Expo_Topic5.png" width="1200px" class="rounded" />

                <div class="B3_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>
                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="TopicB3_Banner01  BannerHover img-thumbnailB3"
                      @click="Savelog_Banner1()"
                    />
                    <span class="TopicB3_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="TopicB3_Banner02 BannerHover img-thumbnailB3"
                      @click="Savelog_Banner2()"
                    />
                    <span class="TopicB3_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="TopicB3_Banner03 BannerHover img-thumbnailB3"
                      @click="Savelog_Banner3()"
                    />
                    <span class="TopicB3_dot3"><i class="far fa-dot-circle"></i></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="TopicB3_Banner04 BannerHover img-thumbnailB3"
                      @click="Savelog_Banner4()"
                    />
                    <span class="TopicB3_dot4"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicB3_Video BannerHover "
                    />

                    <span class="TopicB3_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicB3_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="138px"
                        height="77px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicB3_dotVideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicB3_Video BannerHover "
                    />

                    <span class="TopicB3_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicB3_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicB3_staffArea "></div>
                </span>
              </div>

              <div class="B4 " v-show="Booth_Design == 'B4'">
                <img src="../../assets/images/Expo_Topic6.png" width="1200px" class="rounded" />

                <div class="B4_Logobanner row align-items-center ">
                  <div class="col-4">
                    <div class="logImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="font-weight-bold" style="font-size:15px">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="TopicB4_Banner01  BannerHover img-thumbnailB4"
                      @click="Savelog_Banner1()"
                    />
                    <span class="TopicB4_dot1"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="TopicB4_Banner02 BannerHover img-thumbnailB4"
                      @click="Savelog_Banner2()"
                    />
                    <span class="TopicB4_dot2"><i class="far fa-dot-circle"></i></span>
                  </a>

                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="TopicB4_Banner03 BannerHover img-thumbnailB4"
                      @click="Savelog_Banner3()"
                    />
                    <span class="TopicB4_dot3"><i class="far fa-dot-circle"></i></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="TopicB4_Banner04 BannerHover img-thumbnailB4"
                      @click="Savelog_Banner4()"
                    />
                    <span class="TopicB4_dot4"><i class="far fa-dot-circle"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" TopicB4_Video BannerHover "
                    />

                    <span class="TopicB4_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-if="!ExpovideoLink && videoLink_Youku" class="TopicB4_Video BannerHover">
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="topUK BannerHover">
                      <iframe
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                        width="152px"
                        height="87px"
                      >
                      </iframe>

                      <div class="UKframe"></div>
                    </div>
                    <span class="TopicB4_dotVideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" TopicB4_Video BannerHover "
                    />

                    <span class="TopicB4_dotVideo"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span class="TopicB4_dotCard pointer" @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicB4_staffArea "></div>
                </span>
              </div>

              <!-- 項目ICON列表 -->
              <div class="d-flex iconLine justify-content-around align-items-center " style="color:white">
                <div class="text-center pointer iconOpenHover" @click="openUserModal">
                  <img src="../../assets/images/profile.png" width="65px" alt="" />
                  <div class="mt-2" style="font-size:17px">Profile</div>
                </div>
                <div class="text-center pointer iconOpenHover" @click="openProductModal">
                  <img src="../../assets/images/products.png" width="65px" alt="" />
                  <div class="mt-2" style="font-size:17px">Products</div>
                </div>
                <div class="text-center pointer iconOpenHover" @click="openVideoModal">
                  <img src="../../assets/images/video.png" width="65px" alt="" />
                  <div class="mt-2" style="font-size:17px">Videos</div>
                </div>
                <div class="text-center pointer iconOpenHover" @click="openNewsModal">
                  <img src="../../assets/images/news.png" width="65px" alt="" />
                  <div class="mt-2" style="font-size:17px">Press Release</div>
                </div>
                <div class="text-center pointer iconOpenHover" @click="openInquiryContent">
                  <img src="../../assets/images/chat.png" width="65px" alt="" />
                  <div class="mt-2" style="font-size:17px">Inquiry</div>
                </div>

                <div class="pointer iconOpenHover">
                  <span
                    v-show="ExhInfo.Fav == 0"
                    @click.prevent="ClickFavExh()"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Add to favorites "
                  >
                    <div class="d-flex align-items-end ">
                      <img src="../../assets/images/favorite.png" width="65px" alt="" />
                      <span style="font-size:18px"> {{ ExhInfo.FavCount }}</span>
                    </div>
                    <div class="mt-2" style="font-size:17px">Favorite</div>
                  </span>
                  <span
                    v-show="ExhInfo.Fav == 1"
                    @click.prevent="ClickFavExh()"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=" Remove from favorites"
                  >
                    <div class="d-flex align-items-end">
                      <img src="../../assets/images/favorite_ing.png" width="65px" alt="" />
                      <span style="font-size:18px"> {{ ExhInfo.FavCount }}</span>
                    </div>
                    <div class="mt-2" style="font-size:17px">Favorite</div>
                  </span>
                </div>
                <p style="font-size:16px;z-index: 2001;" class="mt-3 pointer iconOpenHover ">
                  <span @click="openSiderMenu">
                    <span v-visible="!openSider" class="pointer changezIndex">
                      &thinsp; <&thinsp; More Exhibitors
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="MbDevice">
        <div class="container ">
          <div class="d-flex justify-content-center">
            <div v-show="Booth_Design == 'A1'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_Topic1.png" width="320px" />

                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbA1_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbA1_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="mTopicA1_Banner01 BannerHover img-thumbnailA1M "
                      @click="Savelog_Banner1()"
                    />
                    <span class="TopicMbA1_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="mTopicA1_Banner02 BannerHover img-thumbnailA1M "
                      @click="Savelog_Banner2()"
                    />
                    <span class="TopicMbA1_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicA1_Video BannerHover "
                    />
                    <span class="TopicMbA1_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicA1_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbA1_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicA1_Video BannerHover "
                    />

                    <span class="TopicMbA1_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>

            <div v-show="Booth_Design == 'A2'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_Topic2.png" width="320px" />

                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbA2_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbA2_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="mTopicA2_Banner01 BannerHover  " @click="Savelog_Banner1()" />
                    <span class="TopicMbA2_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="mTopicA2_Banner02 BannerHover  " @click="Savelog_Banner2()" />
                    <span class="TopicMbA2_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicA2_Video BannerHover "
                    />
                    <span class="TopicMbA2_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicA2_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbA2_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicA2_Video BannerHover "
                    />

                    <span class="TopicMbA2_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>

            <div v-show="Booth_Design == 'A3'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_TopicA3.png" width="320px" />

                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbA3_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbA3_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="mTopicA3_Banner01 BannerHover  " @click="Savelog_Banner1()" />
                    <span class="TopicMbA3_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="mTopicA3_Banner02 BannerHover  " @click="Savelog_Banner2()" />
                    <span class="TopicMbA3_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicA3_Video BannerHover "
                    />
                    <span class="TopicMbA3_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicA3_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbA3_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicA3_Video BannerHover "
                    />

                    <span class="TopicMbA3_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>

            <div v-show="Booth_Design == 'A4'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_TopicA4.png" width="320px" />

                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbA4_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbA4_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="mTopicA4_Banner01 BannerHover  " @click="Savelog_Banner1()" />
                    <span class="TopicMbA4_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="mTopicA4_Banner02 BannerHover  " @click="Savelog_Banner2()" />
                    <span class="TopicMbA4_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicA4_Video BannerHover "
                    />
                    <span class="TopicMbA4_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicA4_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbA4_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicA4_Video BannerHover "
                    />

                    <span class="TopicMbA4_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>

            <!-- A5 -->
            <div v-show="Booth_Design == 'A5'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_TopicA5.png" width="320px" />

                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbA5_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbA5_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="mTopicA5_Banner01 BannerHover  " @click="Savelog_Banner1()" />
                    <span class="TopicMbA5_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="mTopicA5_Banner02 BannerHover  " @click="Savelog_Banner2()" />
                    <span class="TopicMbA5_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicA5_Video BannerHover "
                    />
                    <span class="TopicMbA5_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicA5_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbA5_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicA5_Video BannerHover "
                    />

                    <span class="TopicMbA5_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>

            <!-- A6 -->
            <div v-show="Booth_Design == 'A6'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_TopicA6.png" width="320px" />

                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbA6_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbA6_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="mTopicA6_Banner01 BannerHover  " @click="Savelog_Banner1()" />
                    <span class="TopicMbA6_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="mTopicA6_Banner02 BannerHover  " @click="Savelog_Banner2()" />
                    <span class="TopicMbA6_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicA6_Video BannerHover "
                    />
                    <span class="TopicMbA6_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicA6_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbA6_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicA6_Video BannerHover "
                    />

                    <span class="TopicMbA6_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>

            <div v-show="Booth_Design == 'B1'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_Topic3.png" width="320px" />

                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbB1_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbB1_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img :src="ExpoM_Banner1" class="mTopicB1_Banner01 BannerHover  " @click="Savelog_Banner1()" />
                    <span class="TopicMbB1_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img :src="ExpoM_Banner2" class="mTopicB1_Banner02 BannerHover " @click="Savelog_Banner2()" />
                    <span class="TopicMbB1_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img :src="ExpoM_Banner3" class="mTopicB1_Banner03 BannerHover " @click="Savelog_Banner3()" />
                    <span class="TopicMbB1_dot3"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img :src="ExpoM_Banner4" class="mTopicB1_Banner04 BannerHover " @click="Savelog_Banner4()" />
                    <span class="TopicMbB1_dot4"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>
                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicB1_Video BannerHover "
                    />
                    <span class="TopicMbB1_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicB1_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbB1_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicB1_Video BannerHover "
                    />

                    <span class="TopicMbB1_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>

            <div v-show="Booth_Design == 'B2'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_Topic4.png" width="320px" />

                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbB2_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbB2_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="mTopicB2_Banner01 BannerHover  img-thumbnailB2"
                      @click="Savelog_Banner1()"
                    />
                    <span class="TopicMbB2_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="mTopicB2_Banner02 BannerHover img-thumbnailB2"
                      @click="Savelog_Banner2()"
                    />
                    <span class="TopicMbB2_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="mTopicB2_Banner03 BannerHover img-thumbnailB2"
                      @click="Savelog_Banner3()"
                    />
                    <span class="TopicMbB2_dot3"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="mTopicB2_Banner04 BannerHover img-thumbnailB2"
                      @click="Savelog_Banner4()"
                    />
                    <span class="TopicMbB2_dot4"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>
                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicB2_Video BannerHover "
                    />
                    <span class="TopicMbB2_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicB2_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbB2_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicB2_Video BannerHover "
                    />

                    <span class="TopicMbB2_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>

            <div v-show="Booth_Design == 'B3'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_Topic5.png" width="320px" />
                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbB3_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbB3_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="mTopicB3_Banner01 BannerHover  img-thumbnailB3"
                      @click="Savelog_Banner1()"
                    />
                    <span class="TopicMbB3_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="mTopicB3_Banner02 BannerHover img-thumbnailB3"
                      @click="Savelog_Banner2()"
                    />
                    <span class="TopicMbB3_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="mTopicB3_Banner03 BannerHover img-thumbnailB3"
                      @click="Savelog_Banner3()"
                    />
                    <span class="TopicMbB3_dot3"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="mTopicB3_Banner04 BannerHover img-thumbnailB3"
                      @click="Savelog_Banner4()"
                    />
                    <span class="TopicMbB3_dot4"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicB3_Video BannerHover "
                    />
                    <span class="TopicMbB3_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicB3_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbB3_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicB3_Video BannerHover "
                    />

                    <span class="TopicMbB3_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>

            <div v-show="Booth_Design == 'B4'">
              <div class="MbExhType BoothSpace">
                <img src="../../assets/images/Expo_Topic6.png" width="320px" />
                <div class="MbLogobanner row align-items-center ">
                  <div class="col-3">
                    <div class="MblogImgFrame">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                        alt=""
                        width="90%"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="LogoText">
                      {{ ExhInfo.ComName }}
                    </div>
                  </div>
                </div>

                <span class="TopicMbB4_dotCard pointer " @click="openInquiryContent"
                  ><i class="far fa-dot-circle"></i>
                  <div class="TopicMbB4_staffArea MbIconSize"></div>
                </span>

                <div v-if="hasBanner">
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="mTopicB4_Banner01 BannerHover  img-thumbnailB4"
                      @click="Savelog_Banner1()"
                    />
                    <span class="TopicMbB4_dot1"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="mTopicB4_Banner02 BannerHover img-thumbnailB4"
                      @click="Savelog_Banner2()"
                    />
                    <span class="TopicMbB4_dot2"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>

                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="mTopicB4_Banner03 BannerHover img-thumbnailB4"
                      @click="Savelog_Banner3()"
                    />
                    <span class="TopicMbB4_dot3"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="mTopicB4_Banner04 BannerHover img-thumbnailB4"
                      @click="Savelog_Banner4()"
                    />
                    <span class="TopicMbB4_dot4"><i class="far fa-dot-circle MbIconSize"></i></span>
                  </a>
                </div>

                <span v-if="ExpovideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                      class=" mTopicB4_Video BannerHover "
                    />
                    <span class="TopicMbB4_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span
                  v-if="!ExpovideoLink && videoLink_Youku"
                  class="mTopicB4_Video BannerHover"
                  style="background-color: #dfdfdfd9"
                >
                  <a
                    :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                    data-fancybox
                    data-type="iframe"
                    data-width="1280"
                    data-height="720"
                    style="color:#434242"
                  >
                    <div class="insideUK" style="color:#5e5e5ecc;margin-top:1px">
                      <i class="fas fa-play-circle "></i>
                    </div>
                    <span class="TopicMbB4_VideoYouKu"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>

                <span v-else-if="!ExpovideoLink && RandomVideoLink">
                  <a
                    :href="`https://www.youtube.com/embed/${RandomVideoLink}`"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    data-fancybox
                    data-width="1280"
                    data-height="720"
                  >
                    <img
                      :src="`https://img.youtube.com/vi/${RandomVideoLink}/mqdefault.jpg`"
                      class=" mTopicB4_Video BannerHover "
                    />

                    <span class="TopicMbB4_Video"><i class="far fa-dot-circle"></i></span>
                  </a>
                </span>
              </div>
            </div>
          </div>

          <div class="Mbfooter">
            <div class="d-flex justify-content-around mt-4">
              <div>
                <div class="text-center pointer iconOpenHover" @click="openUserModal">
                  <img src="../../assets/images/profile.png" width="25px" alt="" />
                  <div class="mt-2" style="font-size:12px">Profile</div>
                </div>
                <div class="text-center pointer iconOpenHover mt-3" @click="openProductModal">
                  <img src="../../assets/images/products.png" width="25px" alt="" />
                  <div class="mt-2" style="font-size:12px">Products</div>
                </div>
              </div>
              <div>
                <div class="text-center pointer iconOpenHover" @click="openVideoModal">
                  <img src="../../assets/images/video.png" width="25px" alt="" />
                  <div class="mt-2" style="font-size:12px">Videos</div>
                </div>

                <div class="text-center pointer iconOpenHover mt-3" @click="openNewsModal">
                  <img src="../../assets/images/news.png" width="25px" alt="" />
                  <div class="mt-2" style="font-size:12px">
                    Press Release
                  </div>
                </div>
              </div>

              <div>
                <div class="text-center pointer iconOpenHover" @click="openInquiryContent">
                  <img src="../../assets/images/chat.png" width="25px" alt="" />
                  <div class="mt-2" style="font-size:12px">Inquiry</div>
                </div>

                <div class="pointer iconOpenHover mt-3">
                  <span v-show="ExhInfo.Fav == 0" @click.prevent="ClickFavExh()">
                    <div class="text-center pointer iconOpenHover">
                      <img src="../../assets/images/favorite.png" width="25px" alt="" />
                      <span style="font-size:10px"> {{ ExhInfo.FavCount }}</span>

                      <div class="mt-2" style="font-size:12px">Favorite</div>
                    </div>
                  </span>
                  <span v-show="ExhInfo.Fav == 1" @click.prevent="ClickFavExh()">
                    <div class="text-center pointer iconOpenHover">
                      <img src="../../assets/images/favorite_ing.png" width="25px" alt="" />
                      <span style="font-size:10px"> {{ ExhInfo.FavCount }}</span>

                      <div class="mt-2" style="font-size:12px">Favorite</div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 彈跳視窗 -->

    <!-- 參展商基本資訊 -->

    <div
      class="modal fade"
      id="UserDesk"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h3 class="title_fontStyle ml-2">
              <img src="../../assets/images/title_profile.png" width="35px" class="mr-1 mb-1" alt="" />
              Company Profile
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-2 px-4">
            <div class="row justify-content-center align-items-center px-4 pb-4">
              <div class="col-lg-3 text-center mb-2">
                <div class="logImgFrame_ExhInfo">
                  <img
                    :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${ExhInfo.ComLogo}`"
                    width="80%"
                    alt=""
                    class="mb-2"
                  />
                </div>
              </div>
              <div class="col-lg-9 text-lg-left text-center">
                <h4>{{ ExhInfo.ComName }}</h4>
                <p>
                  Country: <span>{{ ExhInfo.Country }}</span>
                </p>
                <p>
                  Category: <span>{{ ExhInfo.ExhibArea }}</span>
                </p>
                <p>Booth No: {{ ExhInfo.BoothNo }}</p>
              </div>
            </div>

            <div class="px-4">
              <h4 class="mb-2 mt-4 title_fontStyle ">Exhibitor Profile</h4>

              <p v-html="r_Profile"></p>

              <div v-if="ExhInfo.BrandName.length > 0">
                <h4 class=" title_fontStyle mt-4 mb-2">Brand</h4>
                <p>
                  {{ ExhInfo.BrandName }}
                </p>
              </div>

              <div class="my-4">
                <h5 class="title_fontStyle mt-4 mb-2">Website</h5>
                <a :href="ExhInfo.Url" target="_blank">
                  <span style="color:#3b75dfde">
                    {{ ExhInfo.Url }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 留言區資訊 -->

    <div
      class="modal fade"
      id="openInquiryContent"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h3 class="title_fontStyle ml-2">
              <img src="../../assets/images/title_chat.png" width="35px" class="mr-1" alt="" />

              Inquiry
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-2 px-4">
            <div class="mt-2 mb-4" style="font-size:20px">
              {{ ExhInfo.ComName }}
            </div>
            <div class="row ">
              <div class="col-lg-6 mb-4">
                <p class="font-weight-bold" style="font-size:18px">Name</p>
                <p>{{ Username }}</p>
              </div>
              <div class="col-lg-6 mb-4">
                <p class="font-weight-bold" style="font-size:18px">Email</p>
                <div class="PcDevice">
                  <p>{{ Useremail }}</p>
                </div>

                <div class="MbDevice">
                  <p style="word-break:break-all;width:300px">
                    {{ Useremail }}
                  </p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <label for="inputTel" class="form_title ">Tel</label>
                  <input class="form-control" type="text" id="inputTel" maxlength="30" v-model="CompanyTel" />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <label for="inputTel" class="form_title ">Mobile</label>
                  <input class="form-control " type="text" id="inputTel" maxlength="30" v-model="allPhone" />
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label for="validationTextarea" style="font-size:18px" class="font-weight-bold"
                >Content <span style="color:red">*</span></label
              >
              <textarea
                class="form-control"
                rows="6"
                id="validationTextarea"
                placeholder=""
                v-model="InquiryContent"
                name="Content"
                :class="{ 'is-invalid': errors.first('Content') }"
                v-validate="'required'"
              ></textarea>
              <span class="text-danger" style="font-size: 10px" v-if="errors.first('Content')">
                <i class="fas fa-exclamation-triangle"></i> The Content field is required
              </span>
            </div>
            <div class="text-center">
              <div class="btn btn-primary px-4" @click.prevent="SendInquire">Send</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新聞稿資訊 -->

    <div
      class="modal fade"
      id="openNewsModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h3 class="title_fontStyle ml-2">
              <img src="../../assets/images/title_news.png" width="35px" class="mr-1" alt="" />

              Press Release
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-2 px-4">
            <div v-if="hasNews">
              <div class="my-4 " v-for="(item, index) in ExhNewsList" :key="index">
                <a
                  :href="`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/PressReleaseDetail/${item.NewsNo}`"
                  target="_blank"
                  style="text-decoration:none;"
                >
                  <div class="d-flex">
                    <h5 class="mr-2">{{ index + 1 }}.</h5>
                    <div>
                      <h5 class="title_fontStyle pointer">
                        {{ item.NewsTopic }}
                      </h5>
                      <p class="pointer">
                        {{ item.UpdateTime }}
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div v-else>
              <h4 style="margin-top:0px">
                <div class="d-flex align-items-center">
                  <div class="mb-1">
                    <img src="../../assets/images/paper3.png" width="25px" alt="" />
                  </div>
                  <div class="ml-3">
                    No Data
                  </div>
                </div>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 影片資訊 -->

    <div
      class="modal "
      id="openVideoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
      style="z-index:3000"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h3 class="title_fontStyle ml-2">
              <img src="../../assets/images/title_video.png" width="32px" class="mr-1 mb-1" alt="" />
              Videos
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-2 px-4">
            <div v-if="hasVideo == 0">
              <h4 style="margin-top:0px">
                <div class="d-flex align-items-center">
                  <div class="mb-1">
                    <img src="../../assets/images/paper3.png" width="25px" alt="" />
                  </div>
                  <div class="ml-3">
                    No Data
                  </div>
                </div>
              </h4>
            </div>
            <div v-else>
              <div class="row">
                <div class="col-lg-4 mb-4" v-for="item in exhVideo">
                  <div v-if="item.videoLink">
                    <a
                      :href="`https://www.youtube.com/embed/${item.videoLink}`"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      data-fancybox
                      data-width="1280"
                      data-height="720"
                    >
                      <img
                        :src="`https://img.youtube.com/vi/${item.videoLink}/hqdefault.jpg`"
                        class="BannerHover "
                        width="100%"
                        alt=""
                      />
                    </a>
                  </div>
                  <div v-if="item.videoLink_Youku" class=" BannerHover" style="background-color:#000000">
                    <div>
                      <a
                        :href="`https://player.youku.com/embed/${item.videoLink_Youku}==?rel=0&amp;autoplay=1`"
                        data-fancybox
                        data-type="iframe"
                        data-width="1280"
                        data-height="720"
                      >
                        <div class="topUK BannerHover">
                          <iframe
                            :src="`https://player.youku.com/embed/${item.videoLink_Youku}`"
                            frameborder="0"
                            width="337px"
                            height="247px"
                          >
                          </iframe>

                          <div class="UKframe"></div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div class="my-2 ">
                    <div style="height:50px; font-size:18px; font-weight:bold">{{ item.VideoTopic }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 產品資訊 -->

    <div
      class="modal fade"
      id="openProductModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h3 class="title_fontStyle ml-2">
              <img src="../../assets/images/title_products.png" width="35px" class="mr-1" alt="" />
              Products
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body mb-2 px-4">
            <loading :active.sync="isLoading" background-color="#D0D0D0	">
              <div class="loadingio-spinner-eclipse-y24d302hfm">
                <div class="ldio-f9ujl5oazv5">
                  <div></div>
                </div>
              </div>
            </loading>
            <div v-if="hasProduct">
              <div class="row">
                <div class="col-lg-4 my-3" v-for="item in GetExhPro">
                  <div class="text-center bg-white pointer border card-effect" @click.prevent="goProDetail(item.ProNo)">
                    <div class="logImgFrame_product">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`"
                        width="60%"
                        alt=""
                      />
                    </div>
                    <div class="ProNameFrame px-1">
                      <div style="height:50px; font-weight:bold">
                        <div class="ellipsis_pro">
                          {{ item.ProName }}
                        </div>
                      </div>
                      <div class="mb-2" style="height:30px">
                        <p class="text-muted ellipsis_exh" style="font-size:12px">{{ item.ComName }}</p>
                      </div>
                    </div>
                    <div class="py-1 border-top " @click.stop="ClickFav(item.ProNo)">
                      <span
                        v-show="item.Fav == 1"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Remove from favorites "
                      >
                        <img class=" iconOpenHover" src="../../assets/images/liked.png" width="20px" alt="" />
                        <span style="font-size:14px">
                          {{ item.FavCount }}
                        </span>
                      </span>
                      <span
                        v-show="item.Fav == 0"
                        @click.stop="ClickFav(item.ProNo)"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Add to favorites "
                      >
                        <img class="iconOpenHover" src="../../assets/images/like.png" width="20px" alt="" />
                        <span style="font-size:14px">
                          {{ item.FavCount }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else>
              <h4 style="margin-top:0px">
                <div class="d-flex align-items-center">
                  <div class="mb-1">
                    <img src="../../assets/images/paper3.png" width="25px" alt="" />
                  </div>
                  <div class="ml-3">
                    No Data
                  </div>
                </div>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.prevRoute = from.name
      })
    },
    data() {
      return {
        ExhInfo: {},
        r_Profile: '',
        exhVideo: [],
        ExhNewsList: [],
        GetExhPro: [],
        InterestExhibList: [],
        CardInfo: [],
        Useremail: '',
        Username: '',
        CompanyTel: '',
        allPhone: '',
        Regno: '',
        CSRF_Token: '',
        hasVideo: '',
        // hasCardInfo: true,
        InquiryContent: '',
        hasBanner: true,
        show: true,
        hasNews: true,
        hasProduct: true,

        // 攤位內容
        Booth_Design: '',
        ExpovideoLink: '',
        RandomVideoLink: '',
        videoLink_Youku: '',
        ExpoM_Banner1: '',
        ExpoM_Banner2: '',
        ExpoM_Banner3: '',
        ExpoM_Banner4: '',
        ExpoL_Banner1: '',
        ExpoL_Banner2: '',
        ExpoL_Banner3: '',
        ExpoL_Banner4: '',
        hasBoothType: false, // 有選擇攤販版型
        currentExh: '',

        openSider: false,

        getLastUrl: '',
        prevRoute: null,

        VerifiedCardInfo: [],
        CardInfo2: [],
        hasChatStatue: false,

        SavelogBanner1: '',
        SavelogBanner2: '',
        SavelogBanner3: '',
        SavelogBanner4: '',

        ChangeUrl: '',
        ChangeRegno: '',
      }
    },

    watch: {
      $route(to, from) {
        this.getInitInfo()
      },
    },

    methods: {
      Savelog_Banner1() {
        const vm = this

        if (vm.ChangeUrl) {
          var OpenBNURL1 = `${vm.ChangeUrl}#banner`
        } else {
          let NowPageUrl = location.href
          var OpenBNURL1 = `${NowPageUrl}#banner`
        }

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: 'banner',
          ID: vm.SavelogBanner1,
          Url: OpenBNURL1,
          CSRF: vm.CSRF_Token,
          RegNo: vm.Regno,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      Savelog_Banner2() {
        const vm = this

        if (vm.ChangeUrl) {
          var OpenBNURL2 = `${vm.ChangeUrl}#banner`
        } else {
          let NowPageUrl = location.href
          var OpenBNURL2 = `${NowPageUrl}#banner`
        }
        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: 'banner',
          ID: vm.SavelogBanner2,
          Url: OpenBNURL2,
          CSRF: vm.CSRF_Token,
          RegNo: vm.Regno,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      Savelog_Banner3() {
        const vm = this

        if (vm.ChangeUrl) {
          var OpenBNURL3 = `${vm.ChangeUrl}#banner`
        } else {
          let NowPageUrl = location.href
          var OpenBNURL3 = `${NowPageUrl}#banner`
        }

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: 'banner',
          ID: vm.SavelogBanner3,
          Url: OpenBNURL3,
          CSRF: vm.CSRF_Token,
          RegNo: vm.Regno,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      Savelog_Banner4() {
        const vm = this

        if (vm.ChangeUrl) {
          var OpenBNURL4 = `${vm.ChangeUrl}#banner`
        } else {
          let NowPageUrl = location.href
          var OpenBNURL4 = `${NowPageUrl}#banner`
        }

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: 'banner',
          ID: vm.SavelogBanner4,
          Url: OpenBNURL4,
          CSRF: vm.CSRF_Token,
          RegNo: vm.Regno,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },
      openSiderMenu() {
        const vm = this

        $('.sideMenu').toggleClass('active')

        if (vm.openSider) {
          $('.changezIndex').removeClass('lowZindex')

          vm.openSider = false
        } else {
          $('.changezIndex').addClass('lowZindex')

          vm.openSider = true
        }
      },

      openUserModal() {
        $('#UserDesk').modal('show')

        const vm = this

        if (vm.ChangeUrl) {
          var OpenProfileURL = `${vm.ChangeUrl}#profile`
          var RegnoID = vm.ChangeRegno
        } else {
          let NowPageUrl = location.href
          var OpenProfileURL = `${NowPageUrl}#profile`
          var RegnoID = vm.Regno
        }

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: 'profile',
          ID: RegnoID,
          Url: OpenProfileURL,
          CSRF: vm.CSRF_Token,
          RegNo: vm.Regno,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      openProductModal() {
        const vm = this

        // 取得參展商產品資料
        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/Products/${vm.exhcode}?Regno=${vm.$route.params.MyExhId}&CatNo=&countrycode=&keyword=&Type=Exhibitor&mode=more&Page=&Lang=en`
          )
          .then((response) => {
            if (response.data !== null) {
              vm.hasProduct = true
              vm.GetExhPro = response.data.Products
            } else {
              vm.hasProduct = false
            }
            $('#openProductModal').modal('show')
          })
      },
      openVideoModal() {
        const vm = this
        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/Videos/${vm.exhcode}?Regno=${vm.$route.params.MyExhId}&Page=1&Lang=en`
          )
          .then((response) => {
            vm.exhVideo = response.data.Videos
            vm.hasVideo = response.data.DataTotal
          })

        $('#openVideoModal').modal('show')
      },
      openNewsModal() {
        const vm = this
        $('#openNewsModal').modal('show')

        //取得參展商新聞稿資料
        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/PressReleases/${vm.exhcode}?Regno=${vm.$route.params.MyExhId}&Page=1&Lang=en`
          )
          .then((response) => {
            if (response.data.DataTotal == 0) {
              vm.hasNews = false
            } else {
              vm.hasNews = true
            }
            vm.ExhNewsList = response.data.PressReleases
            vm.$store.dispatch('updateLoading', false)
          })
      },

      openInquiryContent() {
        const vm = this
        vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/regInformation').then((response) => {
          vm.Useremail = response.data.email
          vm.Username = response.data.cname

          if (response.data.Ext) {
            vm.CompanyTel = response.data.Tel + '#' + response.data.Ext
          } else {
            vm.CompanyTel = response.data.Tel
          }
          // //手機組合

          let mobilenum = response.data.mobile
          let mobArea = response.data.MobileCountryCode
          vm.allPhone = mobArea + mobilenum
        })
        $('#openInquiryContent').modal('show')

        if (vm.ChangeUrl) {
          var OpenInquireURL1 = `${vm.ChangeUrl}#inquiry`
        } else {
          let NowPageUrl = location.href
          var OpenInquireURL1 = `${NowPageUrl}#inquiry`
        }

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenInquireURL1,
          CSRF: vm.CSRF_Token,
          RegNo: vm.Regno,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SendInquire() {
        const vm = this

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/Inquire/${vm.exhcode}`
        const info = {
          exhcode: vm.exhcode,
          CSRF: vm.CSRF_Token,
          CName: vm.Username,
          Email: vm.Useremail,
          Tel: vm.CompanyTel,
          Mobile: vm.allPhone,
          Inquiry: vm.InquiryContent,
          Type: 'RNO',
          ID: vm.Regno,
        }

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$store.dispatch('updateLoading', true)
            vm.$http.post(url, info).then(function(response) {
              if (response.data == '200') {
                vm.$store.dispatch('updateLoading', false)
                vm.alertTitle = 'Success'
                vm.alertText = 'Your inquiry has been sent'

                vm.alertSuccess('Inq')
              } else if (response.data == '252') {
                window.location.replace(`https://www.chanchao.com.tw/en/`)
              } else if (response.data == '251') {
                vm.$store.dispatch('updateLoading', false)
                vm.alertText = 'Server is busy, please try again later.'

                vm.alertError()
              } else if (response.data == '253') {
                vm.$store.dispatch('updateLoading', false)
                vm.alertText = ' Email error'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = 'Your request could not be completed.'
            vm.alertError()
          }
        })
      },

      goProDetail(id) {
        window.open(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/ProductDetail/${id}`)
      },

      goExhDetail(id) {
        const vm = this
        this.$router.push(`/ExhibitorDetail/${id}`)

        vm.ChangeUrl = `https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/ExhibitorDetail/${id}`
        vm.ChangeRegno = id
        this.openSiderMenu()
        this.getInitInfo()
      },

      getInitInfo() {
        const vm = this
        vm.show = false
        vm.$store.dispatch('updateLoading', true)

        //取得線上展攤位總資料
        vm.$http
          .get(`https://www.chanchao.com.tw/apiExhibitors/DisplayOnlineExpoControl/${vm.$route.params.MyExhId}`)
          .then((response) => {
            if (response.data.Data.Booth_Design) {
              vm.hasBoothType = true

              vm.Booth_Design = response.data.Data.Booth_Design
            } else {
              vm.hasBoothType = false
              vm.Booth_Design = response.data.Data.Booth_Design_Default
            }

            vm.ExpovideoLink = response.data.Data.video_Link
            vm.RandomVideoLink = response.data.Data.RandomVideoLink
            vm.videoLink_Youku = response.data.Data.videoLink_Youku

            if (
              response.data.Data.Banner1M ||
              response.data.Data.Banner2M ||
              response.data.Data.Banner3M ||
              response.data.Data.Banner4M
            ) {
              vm.hasBanner = true
            } else {
              vm.hasBanner = false
            }

            if (response.data.Data.Banner1L) {
              vm.ExpoM_Banner1 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner1M}`
              vm.ExpoL_Banner1 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner1L}`
              vm.SavelogBanner1 = response.data.Data.Banner1M
            } else {
              vm.ExpoM_Banner1 = './images/default_230x450.jpg'
              vm.ExpoL_Banner1 = './images/default_230x450.jpg'
            }

            if (response.data.Data.Banner2L) {
              vm.ExpoM_Banner2 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner2M}`
              vm.ExpoL_Banner2 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner2L}`
              vm.SavelogBanner2 = response.data.Data.Banner2M
            } else {
              vm.ExpoM_Banner2 = './images/default_230x450.jpg'
              vm.ExpoL_Banner2 = './images/default_230x450.jpg'
            }

            if (response.data.Data.Banner3L) {
              vm.ExpoM_Banner3 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner3M}`
              vm.ExpoL_Banner3 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner3L}`
              vm.SavelogBanner3 = response.data.Data.Banner3M
            } else {
              vm.ExpoM_Banner3 = './images/default_230x450.jpg'
              vm.ExpoL_Banner3 = './images/default_230x450.jpg'
            }

            if (response.data.Data.Banner4L) {
              vm.ExpoM_Banner4 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner4M}`
              vm.ExpoL_Banner4 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner4L}`
              vm.SavelogBanner4 = response.data.Data.Banner4M
            } else {
              vm.ExpoM_Banner4 = './images/default_230x450.jpg'
              vm.ExpoL_Banner4 = './images/default_230x450.jpg'
            }

            //取得參展商Profile資料
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/${vm.$route.params.MyExhId}?Lang=en`
              )
              .then((response) => {
                vm.currentExh = response.data.ComName

                vm.ExhInfo = response.data
                if (response.data.Profile) {
                  vm.r_Profile = response.data.Profile
                }

                vm.$store.dispatch('updateLoading', false)
                vm.show = true

                //取得攤位人員資料
                // vm.$http
                //   .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Boothstaff/${vm.$route.params.MyExhId}`)
                //   .then((response) => {
                //     //取得攤販資料則取消瀏覽畫面

                //     vm.hasChatStatue = false

                //     vm.VerifiedCardInfo = response.data.filter((item) => {
                //       return item.Verified == 1
                //     })

                //     vm.CardInfo = vm.VerifiedCardInfo
                //     vm.CardInfo2 = vm.VerifiedCardInfo

                //     if (vm.CardInfo.length > 0) {
                //       vm.hasCardInfo = true
                //     } else {
                //       vm.hasCardInfo = false
                //     }

                //     for (let i = 0; i < vm.CardInfo2.length; i++) {
                //       vm.$http
                //         .get(
                //           `https://www.chanchao.com.tw/apiOnlineExpo/v1/Boothstaffonline?id=${vm.CardInfo2[i].Email}&group=lt`
                //         )
                //         .then((response) => {
                //           vm.CardInfo2[i].online = response.data

                //           vm.hasChatStatue = vm.CardInfo2.every(function(item) {
                //             return item.online !== undefined
                //           })

                //           if (vm.hasChatStatue) {
                //             vm.CardInfo = vm.CardInfo2
                //           }
                //         })
                //     }
                //   })
              })
          })

        //紀錄瀏覽
        vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
          vm.CSRF_Token = response.data

          let CSRFToken = response.data

          let NowPageUrl = location.href

          const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
          const info = {
            Type: 'RNO',
            ID: vm.$route.params.MyExhId,
            Url: NowPageUrl,
            CSRF: CSRFToken,
            RegNo: vm.Regno,
          }

          vm.$http.post(url, info).then(function(response) {
            if (response.data == '200') {
              // console.log('Log success')
            } else if (response.data == '251') {
              // console.log('Log fail')
            }
          })
        })
      },

      //點喜愛參展商
      ClickFavExh() {
        const vm = this
        var url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/FavoritesExhibitors/${vm.exhcode}/${vm.Regno}`

        const info = {
          CSRF: vm.CSRF_Token,
        }

        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            vm.alertTitle = 'Success'
            vm.alertText = 'Added to favorites'
            vm.alertSuccess('Fav')
          } else if (response.data == '252') {
            vm.alertText = 'CSRF Token驗證錯誤'
            vm.alertError()
            vm.$refs.signupEmail.style.borderColor = 'red'
          } else if (response.data == '251') {
            vm.alertText = 'Server is busy, please try again later.'

            vm.alertError()
          } else if (response.data == '253') {
            vm.alertText = ' Removed from favorites'
            vm.alertCancelFav()
          }
        })
      },

      //點喜愛產品
      ClickFav(ProNo) {
        const vm = this
        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/FavoritesProducts/${vm.exhcode}/${ProNo}`

        const info = {
          CSRF: vm.CSRF_Token,
        }

        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // vm.alertTitle = 'Success'
            // vm.alertText = 'Added to favorites'
            // vm.alertFavProSuccess()

            vm.openProductModal()
          } else if (response.data == '252') {
            vm.alertText = 'CSRF Token驗證錯誤'
            vm.alertError()
            vm.$refs.signupEmail.style.borderColor = 'red'
          } else if (response.data == '251') {
            vm.alertText = 'Server is busy, please try again later.'

            vm.alertError()
          } else if (response.data == '253') {
            // vm.alertText = ' Removed from favorites'
            // vm.alertCancelProFav()

            vm.openProductModal()
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertCancelFav() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function() {
          vm.$http
            .get(
              `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/${vm.$route.params.MyExhId}?Lang=en`
            )
            .then((response) => {
              vm.ExhInfo = response.data
            })
        })
      },

      alertSuccess(Type) {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function() {
          if (Type == 'Fav') {
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/${vm.$route.params.MyExhId}?Lang=en`
              )
              .then((response) => {
                vm.ExhInfo = response.data
              })
          } else if (Type == 'Inq') {
            $('#openInquiryContent').modal('hide')
          }
        })
      },
    },

    computed: {
      ...mapGetters([
        'ListStatus',
        'Roomvisible',
        'UnreadNum',
        'OptionKeyword',
        'SearchArea',
        'Searchcountry',
        'Searchpro',
        'exhcode',
      ]),
    },

    created() {
      $('.modal').modal('hide')

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)
      this.$store.dispatch('updateLoading', true)

      const vm = this
      vm.show = false
      vm.Regno = vm.$route.params.MyExhId

      // 取得參展商Profile資料
      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorsDetail/${vm.exhcode}/${vm.Regno}?Lang=en`)
        .then((response) => {
          vm.currentExh = response.data.ComName
          vm.ExhInfo = response.data

          if (response.data.Profile) {
            vm.r_Profile = response.data.Profile
          }

          //取得線上展攤位總資料
          vm.$http
            .get(`https://www.chanchao.com.tw/apiExhibitors/DisplayOnlineExpoControl/${vm.Regno}`)
            .then((response) => {
              vm.ExpovideoLink = response.data.Data.video_Link
              vm.RandomVideoLink = response.data.Data.RandomVideoLink
              vm.videoLink_Youku = response.data.Data.videoLink_Youku

              if (response.data.Data.Booth_Design) {
                vm.hasBoothType = true
                vm.Booth_Design = response.data.Data.Booth_Design
                vm.show = true
                vm.$store.dispatch('updateLoading', false)
              } else {
                vm.hasBoothType = false
                vm.Booth_Design = response.data.Data.Booth_Design_Default
                vm.show = true
                vm.$store.dispatch('updateLoading', false)
              }

              if (
                response.data.Data.Banner1M ||
                response.data.Data.Banner2M ||
                response.data.Data.Banner3M ||
                response.data.Data.Banner4M
              ) {
                vm.hasBanner = true
              } else {
                vm.hasBanner = false
              }

              if (response.data.Data.Banner1L) {
                vm.ExpoM_Banner1 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner1M}`
                vm.ExpoL_Banner1 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner1L}`

                vm.SavelogBanner1 = response.data.Data.Banner1M
              } else {
                vm.ExpoM_Banner1 = './images/default_230x450.jpg'
                vm.ExpoL_Banner1 = './images/default_230x450.jpg'
              }

              if (response.data.Data.Banner2L) {
                vm.ExpoM_Banner2 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner2M}`
                vm.ExpoL_Banner2 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner2L}`
                vm.SavelogBanner2 = response.data.Data.Banner2M
              } else {
                vm.ExpoM_Banner2 = './images/default_230x450.jpg'
                vm.ExpoL_Banner2 = './images/default_230x450.jpg'
              }

              if (response.data.Data.Banner3L) {
                vm.ExpoM_Banner3 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner3M}`
                vm.ExpoL_Banner3 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner3L}`
                vm.SavelogBanner3 = response.data.Data.Banner3M
              } else {
                vm.ExpoM_Banner3 = './images/default_230x450.jpg'
                vm.ExpoL_Banner3 = './images/default_230x450.jpg'
              }

              if (response.data.Data.Banner4L) {
                vm.ExpoM_Banner4 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner4M}`
                vm.ExpoL_Banner4 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner4L}`
                vm.SavelogBanner4 = response.data.Data.Banner4M
              } else {
                vm.ExpoM_Banner4 = './images/default_230x450.jpg'
                vm.ExpoL_Banner4 = './images/default_230x450.jpg'
              }
            })

          //取得攤位人員資料
          vm.$http
            .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Boothstaff/${vm.$route.params.MyExhId}`)
            .then((response) => {
              vm.VerifiedCardInfo = response.data.filter((item) => {
                return item.Verified == 1
              })

              vm.CardInfo = vm.VerifiedCardInfo
              vm.CardInfo2 = vm.VerifiedCardInfo

              // if (vm.CardInfo.length > 0) {
              //   vm.hasCardInfo = true
              // } else {
              //   vm.hasCardInfo = false
              // }

              for (let i = 0; i < vm.CardInfo2.length; i++) {
                vm.$http
                  .get(
                    `https://www.chanchao.com.tw/apiOnlineExpo/v1/Boothstaffonline?id=${vm.CardInfo2[i].Email}&group=lt`
                  )
                  .then((response) => {
                    vm.CardInfo2[i].online = response.data

                    vm.hasChatStatue = vm.CardInfo2.every(function(item) {
                      return item.online !== undefined
                    })

                    if (vm.hasChatStatue) {
                      vm.CardInfo = vm.CardInfo2
                    }
                  })
              }
            })

          //取得感興趣的參展商資料

          if (vm.prevRoute == 'AdvanceSearchExhibitors') {
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitors/${vm.exhcode}?AreaNo=${vm.SearchArea}&CatNo=${vm.Searchpro}&countrycode=${vm.Searchcountry}&keyword=${vm.OptionKeyword}&Type=Exhibitor&Page=1&Lang=en&mode=more`
              )
              .then((response) => {
                vm.InterestExhibList = response.data.Exhibitors
              })
          } else if (vm.prevRoute == 'FavoriteExhibitors') {
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitors/${vm.exhcode}?AreaNo=&CatNo=&countrycode=&keyword=&Type=Fav&Page=1&Lang=en&mode=more`
              )
              .then((response) => {
                vm.InterestExhibList = response.data.Exhibitors
              })
          } else if (vm.prevRoute == 'BrowsingHistoryExhibitors') {
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitors/${vm.exhcode}?AreaNo=&CatNo=&countrycode=&keyword=&Type=Seen&Page=1&Lang=en&mode=more`
              )
              .then((response) => {
                vm.InterestExhibList = response.data.Exhibitors
              })
          } else {
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitors/${vm.exhcode}?AreaNo=&CatNo=&countrycode=&keyword=&Type=null&Page=&Lang=en&mode=more`
              )
              .then((response) => {
                vm.InterestExhibList = response.data.Exhibitors
              })
          }
        })

      //紀錄瀏覽
      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        vm.CSRF_Token = response.data

        let CSRFToken = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: 'RNO',
          ID: vm.$route.params.MyExhId,
          Url: NowPageUrl,
          CSRF: CSRFToken,
          RegNo: vm.Regno,
        }

        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss">
  .modal-content {
    height: 82vh;
  }

  .modal.fade {
    z-index: 10000 !important;
  }

  .modal-body {
    overflow-y: scroll;
    height: 75vh;
  }

  .logImgFrame_product {
    width: 230px;
    min-height: 160px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logImgFrame_Chat {
    width: 150px;
    min-height: 150px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logImgFrame {
    width: 100px;
    min-height: 100px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .MblogImgFrame {
    width: 50px;
    min-height: 50px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .homesection {
    background-image: url('../../assets/images/booth_bg1.jpg');
    background-size: cover;
    background-position: center center;
    height: 920px;
    z-index: 998;
    margin-top: 80px;
  }

  @media (max-width: 576px) {
    .homesection {
      background-image: url('../../assets/images/booth_bg1.jpg');
      background-size: cover;
      background-position: center center;
      height: 600px;
      z-index: 998;
      margin-top: 70px;
    }

    .modal-content {
      height: auto;
    }
  }

  .Logobanner {
    position: absolute;
    right: 350px;
    top: 90px;
    width: 430px;
    min-height: 70px;
    /* border: #326f8b 2px solid; */
    border-radius: 2%;
    background-color: #eceff0;
  }

  .booth {
    position: absolute;
    right: 350px;
    top: 200px;
  }

  .iconLine {
    z-index: 999;
  }

  .rightline {
    border-right: rgb(223, 220, 220) 2px solid;
    height: 300px;
  }

  a,
  label {
    cursor: pointer;
  }

  .SliderFrame {
    margin-right: 300px;
    position: fixed;
    top: 88px;
    bottom: 0;
    right: 0;
    z-index: 2000;
    width: 0px;
  }

  @media (max-width: 576px) {
    .SliderFrame {
      margin-right: 300px;
      position: fixed;
      top: 80px;
      bottom: 0;
      right: 0;
      z-index: 2000;
      width: 0px;
    }
  }

  .sideMenu {
    width: 300px;
    height: 80vh;
    background-color: rgba(247, 247, 247, 0.912);
    border-left: 3px solid #d1d1d1;
    display: flex;
    flex-direction: column; //主軸
    box-shadow: 5px 0 5px rgba(23, 23, 54, 0.6);
    position: relative; // label 定位在這個上
    transform: translateX(100%); // 將 sideMenu 左橫移 100%，使他到螢幕外
    transition: 0.5s; // 側邊選單收合的時間差
    z-index: 900;
    margin-top: 5px;

    &.active {
      transform: translateX(0);
    }

    label {
      box-shadow: 5px 0 5px rgba(23, 23, 54, 0.6);
      width: 32px;
      height: 210px;
      background-color: #2f63c2d6;
      color: #ffffff;
      position: absolute;
      left: -35px;
      bottom: 0;
      top: 0;
      margin: auto;
      line-height: 33px;
      text-align: center;
      border-radius: 5px 0 0 5px;
      writing-mode: vertical-lr;
      cursor: pointer;
    }
  }

  .sidemenu {
    overflow-y: auto;

    &.active {
      transform: translateX(0px);
      display: block;
    }

    &:hover {
      cursor: pointer;
    }
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  //卡片區
  .card-header {
    margin-bottom: 0;
    background-color: #dadddd;
    border-bottom: 0px;
    position: relative;
  }

  .card {
    -webkit-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
    -moz-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
    box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
    min-height: 310px;

    @media (max-width: 576px) {
      min-height: 240px;
    }
  }

  //攤販圖

  //定位外框

  .ExhType {
    max-width: 1300px;
    max-height: 1300px;
    /* overflow-x: scroll; */
    background-repeat: no-repeat;
    position: relative;
  }

  @keyframes flicker {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.3;
    }

    100% {
      opacity: 1.2;
    }
  }

  .PickedExh {
    color: #1650f1;
    font-weight: bold;
  }

  .ExhHover:hover {
    color: #3a7cdf;
    cursor: pointer;
  }

  .MbLogobanner {
    position: absolute;
    left: 55px;
    top: -115px;
    width: 250px;
    min-height: 60px;
    border-radius: 5px;
    background-color: #eceff0;
    border: 1px solid #b6beca;
  }

  .LogoText {
    font-family: monospace;
    font-size: 12px;
    font-weight: 550;
  }

  // 攤位A1

  .A1_Logobanner {
    position: absolute;
    right: 193px;
    top: 67px;
    width: 440px;
    min-height: 100px;
    border-radius: 2%;
    background-color: #eceff0;
  }

  .TopicA1_Banner01 {
    position: absolute;
    left: 638px;
    top: 211px;
    width: 114px;
    height: 202px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA1_Banner02 {
    position: absolute;
    left: 787px;
    top: 211px;
    width: 115px;
    height: 202px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .img-thumbnailA1 {
    border: 1px solid #63686a;
    border-radius: 0.15rem;
    max-width: 100%;
  }

  .TopicA1_dot1 {
    position: absolute;
    left: 689px;
    top: 180px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .TopicA1_dot2 {
    position: absolute;
    left: 835px;
    top: 180px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .TopicA1_dotVideo {
    position: absolute;
    left: 468px;
    top: 165px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .TopicA1_dotVideoYouku {
    position: absolute;
    left: 67px;
    top: -33px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .TopicA1_Video {
    position: absolute;
    left: 402px;
    top: 200px;
    width: 149px;
    height: 89px;
  }

  .TopicA1_dotCard {
    position: absolute;
    left: 245px;
    top: 262px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .TopicA1_staffArea {
    position: absolute;
    left: -75px;
    top: -7px;
    width: 155px;
    height: 192px;
  }

  // 攤位圖 A2

  .A2_Logobanner {
    position: absolute;
    right: 625px;
    top: 125px;
    width: 390px;
    min-height: 100px;
    /* border: #326f8b 2px solid; */
    border-radius: 2%;
    background-color: #eceff0;
  }

  .TopicA2_Banner01 {
    position: absolute;
    left: 208px;
    top: 315px;
    width: 115px;
    height: 202px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA2_Banner02 {
    position: absolute;
    left: 351px;
    top: 315px;
    width: 115px;
    height: 202px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA2_dot1 {
    position: absolute;
    left: 259px;
    top: 279px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA2_dot2 {
    position: absolute;
    left: 400px;
    top: 279px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA2_dotVideo {
    position: absolute;
    left: 938px;
    top: 320px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA2_dotVideoYouKu {
    position: absolute;
    left: 63px;
    top: -30px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA2_Video {
    position: absolute;
    left: 875px;
    top: 354px;
    width: 142px;
    height: 82px;
  }

  .TopicA2_dotCard {
    position: absolute;
    left: 785px;
    top: 320px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA2_staffArea {
    position: absolute;
    left: -70px;
    top: -7px;
    width: 155px;
    height: 192px;
  }

  // 攤位圖 A3

  .A3_Logobanner {
    position: absolute;
    right: 267px;
    top: 75px;
    width: 390px;
    min-height: 100px;
    /* border: #326f8b 2px solid; */
    border-radius: 2%;
    background-color: #eceff0;
  }

  .TopicA3_Banner01 {
    position: absolute;
    left: 675px;
    top: 207px;
    width: 110px;
    height: 217px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA3_Banner02 {
    position: absolute;
    left: 816px;
    top: 207px;
    width: 110px;
    height: 217px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA3_dot1 {
    position: absolute;
    left: 723px;
    top: 183px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA3_dot2 {
    position: absolute;
    left: 864px;
    top: 183px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA3_dotVideo {
    position: absolute;
    left: 397px;
    top: 179px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA3_dotVideoYouKu {
    position: absolute;
    left: 68px;
    top: -27px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA3_Video {
    position: absolute;
    left: 329px;
    top: 209px;
    width: 150px;
    height: 90px;
  }

  .TopicA3_dotCard {
    position: absolute;
    left: 165px;
    top: 430px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA3_staffArea {
    position: absolute;
    left: -70px;
    top: -220px;
    width: 155px;
    height: 292px;
  }

  // 攤位圖 A4

  .A4_Logobanner {
    position: absolute;
    right: 430px;
    top: 138px;
    width: 362px;
    min-height: 100px;
    border-radius: 2%;
    background-color: #eceff0;
  }

  .TopicA4_Banner01 {
    position: absolute;
    left: 302px;
    top: 231px;
    width: 107px;
    height: 217px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA4_Banner02 {
    position: absolute;
    left: 790px;
    top: 231px;
    width: 107px;
    height: 217px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA4_dot1 {
    position: absolute;
    left: 349px;
    top: 207px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA4_dot2 {
    position: absolute;
    left: 835px;
    top: 207px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA4_dotVideo {
    position: absolute;
    left: 598px;
    top: 249px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA4_dotVideoYouKu {
    position: absolute;
    left: 72px;
    top: -29px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA4_Video {
    position: absolute;
    left: 528px;
    top: 276px;
    width: 155px;
    height: 102px;
  }

  .TopicA4_dotCard {
    position: absolute;
    left: 946px;
    top: 300px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA4_staffArea {
    position: absolute;
    left: -42px;
    top: -10px;
    width: 125px;
    height: 222px;
  }

  // 攤位圖 A5

  .A5_Logobanner {
    position: absolute;
    right: 184px;
    top: 81px;
    width: 390px;
    min-height: 100px;
    /* border: #326f8b 2px solid; */
    border-radius: 2%;
    background-color: #eceff0;
  }

  .TopicA5_Banner01 {
    position: absolute;
    left: 198px;
    top: 247px;
    width: 109px;
    height: 217px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA5_Banner02 {
    position: absolute;
    left: 320px;
    top: 247px;
    width: 109px;
    height: 217px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA5_dot1 {
    position: absolute;
    left: 249px;
    top: 220px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA5_dot2 {
    position: absolute;
    left: 365px;
    top: 220px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA5_dotVideo {
    position: absolute;
    left: 929px;
    top: 259px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA5_dotVideoYouKu {
    position: absolute;
    left: 72px;
    top: -32px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA5_Video {
    position: absolute;
    left: 862px;
    top: 288px;
    width: 155px;
    height: 102px;
  }

  .TopicA5_dotCard {
    position: absolute;
    left: 779px;
    top: 300px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA5_staffArea {
    position: absolute;
    left: -52px;
    top: -10px;
    width: 125px;
    height: 222px;
  }

  // 攤位圖 A6

  .A6_Logobanner {
    position: absolute;
    right: 650px;
    top: 70px;
    width: 390px;
    min-height: 100px;
    /* border: #326f8b 2px solid; */
    border-radius: 2%;
    background-color: #eceff0;
  }

  .TopicA6_Banner01 {
    position: absolute;
    left: 444px;
    top: 301px;
    width: 108px;
    height: 213px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA6_Banner02 {
    position: absolute;
    left: 569px;
    top: 301px;
    width: 108px;
    height: 213px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicA6_dot1 {
    position: absolute;
    left: 491px;
    top: 272px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA6_dot2 {
    position: absolute;
    left: 617px;
    top: 272px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA6_dotVideo {
    position: absolute;
    left: 293px;
    top: 299px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA6_dotVideoYouKu {
    position: absolute;
    left: 73px;
    top: -31px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA6_Video {
    position: absolute;
    left: 221px;
    top: 330px;
    width: 155px;
    height: 102px;
  }

  .TopicA6_dotCard {
    position: absolute;
    left: 883px;
    top: 315px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicA6_staffArea {
    position: absolute;
    left: -58px;
    top: -10px;
    width: 146px;
    height: 222px;
  }

  // 攤位圖 B1

  .B1_Logobanner {
    position: absolute;
    right: 328px;
    top: 61px;
    width: 390px;
    min-height: 100px;
    border-radius: 2%;
    background-color: #eceff0;
  }

  .TopicB1_Banner01 {
    position: absolute;
    left: 59px;
    top: 303px;
    width: 109px;
    height: 198px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB1_Banner02 {
    position: absolute;
    left: 212px;
    top: 303px;
    width: 109px;
    height: 198px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB1_Banner03 {
    position: absolute;
    left: 361px;
    top: 303px;
    width: 105px;
    height: 194px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB1_Banner04 {
    position: absolute;
    left: 507px;
    top: 309px;
    width: 105px;
    height: 194px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB1_dot1 {
    position: absolute;
    left: 108px;
    top: 271px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB1_dot2 {
    position: absolute;
    left: 260px;
    top: 271px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB1_dot3 {
    position: absolute;
    left: 406px;
    top: 271px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB1_dot4 {
    position: absolute;
    left: 552px;
    top: 271px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB1_dotVideo {
    position: absolute;
    left: 998px;
    top: 190px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicB1_dotVideoYouKu {
    position: absolute;
    left: 82px;
    top: -29px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB1_Video {
    position: absolute;
    left: 917px;
    top: 222px;
    width: 177px;
    height: 104px;
  }

  .TopicB1_dotCard {
    position: absolute;
    left: 1025px;
    top: 490px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB1_staffArea {
    position: absolute;
    left: -60px;
    top: -145px;
    width: 155px;
    height: 202px;
  }

  // 攤位圖 B2

  .B2_Logobanner {
    position: absolute;
    right: 67px;
    top: 107px;
    width: 390px;
    min-height: 100px;
    /* border: #326f8b 2px solid; */
    border-radius: 2%;
    background-color: #eceff0;
  }

  .img-thumbnailB2 {
    border: 1px solid #d3d2d0;
    border-radius: 0.15rem;
    max-width: 100%;
    height: auto;
  }

  .TopicB2_Banner01 {
    position: absolute;
    left: 114px;
    top: 325px;
    width: 98px;
    height: 170px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB2_Banner02 {
    position: absolute;
    left: 236px;
    top: 325px;
    width: 98px;
    height: 170px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB2_Banner03 {
    position: absolute;
    left: 356px;
    top: 325px;
    width: 98px;
    height: 170px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB2_Banner04 {
    position: absolute;
    left: 478px;
    top: 325px;
    width: 98px;
    height: 170px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB2_dot1 {
    position: absolute;
    left: 158px;
    top: 288px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB2_dot2 {
    position: absolute;
    left: 278px;
    top: 288px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB2_dot3 {
    position: absolute;
    left: 403px;
    top: 288px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB2_dot4 {
    position: absolute;
    left: 522px;
    top: 288px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB2_dotVideo {
    position: absolute;
    left: 708px;
    top: 308px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB2_dotVideoYouKu {
    position: absolute;
    left: 68px;
    top: -28px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB2_Video {
    position: absolute;
    left: 643px;
    top: 339px;
    width: 149px;
    height: 88px;
  }

  .TopicB2_dotCard {
    position: absolute;
    left: 975px;
    top: 335px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB2_staffArea {
    position: absolute;
    left: -60px;
    top: -5px;
    width: 155px;
    height: 202px;
  }

  // 攤位圖 B3

  .B3_Logobanner {
    position: absolute;
    right: 232px;
    top: 154px;
    width: 350px;
    min-height: 80px;
    /* border: #326f8b 2px solid; */
    border-radius: 2%;
    background-color: #eceff0;
  }

  .img-thumbnailB3 {
    border: 2px solid #d5d2d0;
    border-radius: 0.15rem;
    max-width: 100%;
    height: auto;
  }

  .TopicB3_Banner01 {
    position: absolute;
    left: 212px;
    top: 294px;
    width: 67px;
    height: 132px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB3_Banner02 {
    position: absolute;
    left: 295px;
    top: 294px;
    width: 67px;
    height: 132px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB3_Banner03 {
    position: absolute;
    left: 374px;
    top: 294px;
    width: 67px;
    height: 132px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB3_Banner04 {
    position: absolute;
    left: 456px;
    top: 294px;
    width: 67px;
    height: 132px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB3_dot1 {
    position: absolute;
    left: 238px;
    top: 273px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB3_dot2 {
    position: absolute;
    left: 319px;
    top: 273px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB3_dot3 {
    position: absolute;
    left: 399px;
    top: 273px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB3_dot4 {
    position: absolute;
    left: 482px;
    top: 273px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB3_dotVideo {
    position: absolute;
    left: 635px;
    top: 248px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB3_dotVideoYouKu {
    position: absolute;
    left: 63px;
    top: -34px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB3_Video {
    position: absolute;
    left: 574px;
    top: 297px;
    width: 139px;
    height: 78px;
  }

  .TopicB3_dotCard {
    position: absolute;
    left: 885px;
    top: 388px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB3_staffArea {
    position: absolute;
    left: -55px;
    top: -80px;
    width: 125px;
    height: 132px;
  }

  // 攤位圖 B4
  .B4_Logobanner {
    position: absolute;
    right: 208px;
    top: 147px;
    width: 390px;
    min-height: 100px;
    /* border: #326f8b 2px solid; */
    border-radius: 2%;
    background-color: #eceff0;
  }

  .img-thumbnailB4 {
    border: 1px solid #cfcbc7;
    border-radius: 0.15rem;
    max-width: 100%;
  }

  .TopicB4_Banner01 {
    position: absolute;
    left: 357px;
    top: 332px;
    width: 73px;
    height: 148px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB4_Banner02 {
    position: absolute;
    left: 451px;
    top: 332px;
    width: 73px;
    height: 148px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB4_Banner03 {
    position: absolute;
    left: 616px;
    top: 328px;
    width: 75px;
    height: 152px;

    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB4_Banner04 {
    position: absolute;
    left: 710px;
    top: 328px;
    width: 74px;
    height: 152px;

    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .TopicB4_dot1 {
    position: absolute;
    left: 385px;
    top: 307px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB4_dot2 {
    position: absolute;
    left: 479px;
    top: 307px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB4_dot3 {
    position: absolute;
    left: 646px;
    top: 304px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB4_dot4 {
    position: absolute;
    left: 739px;
    top: 304px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB4_dotVideo {
    position: absolute;
    left: 1050px;
    top: 305px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB4_dotVideoYouKu {
    position: absolute;
    left: 69px;
    top: -25px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB4_Video {
    position: absolute;
    left: 989px;
    top: 334px;
    width: 153px;
    height: 86px;
  }

  .TopicB4_dotCard {
    position: absolute;
    left: 220px;
    top: 430px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicB4_staffArea {
    position: absolute;
    left: -60px;
    top: -105px;
    width: 155px;
    height: 172px;
  }

  // 手機板攤位區域

  .BoothSpace {
    margin-top: 190px;
  }

  .MbExhType {
    position: relative;
  }

  .MbIconSize {
    font-size: 10px;
  }

  .img-thumbnailA1M {
    border: 1px solid #63686a;
    border-radius: 0.15rem;
    max-width: 100%;
    height: auto;
  }
  .mTopicA1_Banner01 {
    position: absolute;
    left: 170px;
    top: 56px;
    width: 30px;
    height: 55px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA1_Banner02 {
    position: absolute;
    left: 210px;
    top: 56px;
    width: 30px;
    height: 55px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA1_Video {
    position: absolute;
    left: 107px;
    top: 53px;
    width: 40px;
    height: 24px;
  }
  .TopicMbA1_dot1 {
    position: absolute;
    left: 181px;
    top: 38px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .TopicMbA1_dot2 {
    position: absolute;
    left: 220px;
    top: 38px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }
  .TopicMbA1_Video {
    position: absolute;
    left: 120px;
    top: 34px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .TopicMbA1_VideoYouKu {
    position: absolute;
    left: 13px;
    top: -21px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .TopicMbA1_dotCard {
    position: absolute;
    left: 61px;
    top: 62px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .mTopicA2_Banner01 {
    position: absolute;
    left: 56px;
    top: 84px;
    width: 31px;
    height: 54px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA2_Banner02 {
    position: absolute;
    left: 93px;
    top: 84px;
    width: 31px;
    height: 54px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA2_Video {
    position: absolute;
    left: 233px;
    top: 94px;
    width: 38px;
    height: 22px;
  }
  .TopicMbA2_dot1 {
    position: absolute;
    left: 66px;
    top: 65px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA2_dot2 {
    position: absolute;
    left: 103px;
    top: 65px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbA2_Video {
    position: absolute;
    left: 245px;
    top: 74px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA2_VideoYouKu {
    position: absolute;
    left: 12px;
    top: -21px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA2_dotCard {
    position: absolute;
    left: 205px;
    top: 75px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  //A3
  .mTopicA3_Banner01 {
    position: absolute;
    left: 180px;
    top: 56px;
    width: 29px;
    height: 58px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA3_Banner02 {
    position: absolute;
    left: 218px;
    top: 56px;
    width: 29px;
    height: 58px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA3_Video {
    position: absolute;
    left: 87px;
    top: 55px;
    width: 41px;
    height: 25px;
  }
  .TopicMbA3_dot1 {
    position: absolute;
    left: 190px;
    top: 35px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA3_dot2 {
    position: absolute;
    left: 226px;
    top: 35px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbA3_Video {
    position: absolute;
    left: 100px;
    top: 35px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA3_VideoYouKu {
    position: absolute;
    left: 13px;
    top: -20px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA3_dotCard {
    position: absolute;
    left: 37px;
    top: 110px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  //A4
  .mTopicA4_Banner01 {
    position: absolute;
    left: 80px;
    top: 61px;
    width: 30px;
    height: 58px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA4_Banner02 {
    position: absolute;
    left: 210px;
    top: 61px;
    width: 30px;
    height: 58px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA4_Video {
    position: absolute;
    left: 141px;
    top: 73px;
    width: 41px;
    height: 28px;
  }
  .TopicMbA4_dot1 {
    position: absolute;
    left: 90px;
    top: 41px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA4_dot2 {
    position: absolute;
    left: 220px;
    top: 41px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbA4_Video {
    position: absolute;
    left: 154px;
    top: 50px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA4_VideoYouKu {
    position: absolute;
    left: 13px;
    top: -22px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA4_dotCard {
    position: absolute;
    left: 247px;
    top: 65px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  //A5
  .mTopicA5_Banner01 {
    position: absolute;
    left: 52px;
    top: 66px;
    width: 30px;
    height: 58px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA5_Banner02 {
    position: absolute;
    left: 85px;
    top: 66px;
    width: 30px;
    height: 58px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA5_Video {
    position: absolute;
    left: 230px;
    top: 76px;
    width: 41px;
    height: 28px;
  }
  .TopicMbA5_dot1 {
    position: absolute;
    left: 63px;
    top: 45px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA5_dot2 {
    position: absolute;
    left: 95px;
    top: 45px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbA5_Video {
    position: absolute;
    left: 242px;
    top: 54px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA5_VideoYouKu {
    position: absolute;
    left: 13px;
    top: -22px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA5_dotCard {
    position: absolute;
    left: 202px;
    top: 125px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  //A6
  .mTopicA6_Banner01 {
    position: absolute;
    left: 118px;
    top: 80px;
    width: 30px;
    height: 58px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA6_Banner02 {
    position: absolute;
    left: 150px;
    top: 80px;
    width: 30px;
    height: 58px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicA6_Video {
    position: absolute;
    left: 59px;
    top: 87px;
    width: 41px;
    height: 28px;
  }
  .TopicMbA6_dot1 {
    position: absolute;
    left: 127px;
    top: 58px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA6_dot2 {
    position: absolute;
    left: 159px;
    top: 58px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbA6_Video {
    position: absolute;
    left: 73px;
    top: 65px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA6_VideoYouKu {
    position: absolute;
    left: 14px;
    top: -21px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbA6_dotCard {
    position: absolute;
    left: 230px;
    top: 125px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .mTopicB1_Banner01 {
    position: absolute;
    left: 14px;
    top: 80px;
    width: 31px;
    height: 54px;
    border: 1px solid rgb(163, 159, 159);
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB1_Banner02 {
    position: absolute;
    left: 56px;
    top: 81px;
    width: 29px;
    height: 52px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB1_Banner03 {
    position: absolute;
    left: 96px;
    top: 81px;
    width: 28px;
    height: 51px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB1_Banner04 {
    position: absolute;
    left: 135px;
    top: 82px;
    width: 28px;
    height: 52px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .mTopicB1_Video {
    position: absolute;
    left: 244px;
    top: 59px;
    width: 48px;
    height: 28px;
  }

  .TopicMbB1_dot1 {
    position: absolute;
    left: 22px;
    top: 60px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB1_dot2 {
    position: absolute;
    left: 64px;
    top: 60px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB1_dot3 {
    position: absolute;
    left: 103px;
    top: 60px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB1_dot4 {
    position: absolute;
    left: 144px;
    top: 60px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB1_Video {
    position: absolute;
    left: 261px;
    top: 37px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB1_VideoYouKu {
    position: absolute;
    left: 16px;
    top: -21px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB1_dotCard {
    position: absolute;
    left: 278px;
    top: 128px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .mTopicB2_Banner01 {
    position: absolute;
    left: 30px;
    top: 86px;
    width: 27px;
    height: 46px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB2_Banner02 {
    position: absolute;
    left: 63px;
    top: 86px;
    width: 26px;
    height: 46px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB2_Banner03 {
    position: absolute;
    left: 96px;
    top: 86px;
    width: 26px;
    height: 46px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB2_Banner04 {
    position: absolute;
    left: 127px;
    top: 86px;
    width: 27px;
    height: 46px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .TopicMbB2_dot1 {
    position: absolute;
    left: 37px;
    top: 66px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbB2_dot2 {
    position: absolute;
    left: 70px;
    top: 66px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB2_dot3 {
    position: absolute;
    left: 103px;
    top: 66px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB2_dot4 {
    position: absolute;
    left: 135px;
    top: 66px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbB2_Video {
    position: absolute;
    left: 185px;
    top: 69px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB2_VideoYouKu {
    position: absolute;
    left: 12px;
    top: -21px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .mTopicB2_Video {
    position: absolute;
    left: 171px;
    top: 90px;
    width: 40px;
    height: 24px;
  }

  .TopicMbB2_dotCard {
    position: absolute;
    left: 254px;
    top: 78px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .mTopicB3_Banner01 {
    position: absolute;
    left: 57px;
    top: 78px;
    width: 18px;
    height: 36px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .mTopicB3_Banner02 {
    position: absolute;
    left: 79px;
    top: 78px;
    width: 18px;
    height: 36px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .mTopicB3_Banner03 {
    position: absolute;
    left: 99px;
    top: 78px;
    width: 18px;
    height: 36px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .mTopicB3_Banner04 {
    position: absolute;
    left: 122px;
    top: 78px;
    width: 18px;
    height: 36px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB3_Video {
    position: absolute;
    left: 153px;
    top: 80px;
    width: 37px;
    height: 20px;
  }

  .TopicMbB3_dot1 {
    position: absolute;
    left: 60px;
    top: 59px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB3_dot2 {
    position: absolute;
    left: 82px;
    top: 59px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB3_dot3 {
    position: absolute;
    left: 103px;
    top: 59px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB3_dot4 {
    position: absolute;
    left: 125px;
    top: 59px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB3_Video {
    position: absolute;
    left: 166px;
    top: 55px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB3_VideoYouKu {
    position: absolute;
    left: 11px;
    top: -21px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbB3_dotCard {
    position: absolute;
    left: 232px;
    top: 96px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .mTopicB4_Banner01 {
    position: absolute;
    left: 94px;
    top: 88px;
    width: 21px;
    height: 40px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .mTopicB4_Banner02 {
    position: absolute;
    left: 120px;
    top: 88px;
    width: 21px;
    height: 40px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB4_Banner03 {
    position: absolute;
    left: 164px;
    top: 88px;
    width: 21px;
    height: 40px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB4_Banner04 {
    position: absolute;
    left: 189px;
    top: 88px;
    width: 21px;
    height: 40px;
    transition: all 1s;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .mTopicB4_Video {
    position: absolute;
    left: 264px;
    top: 89px;
    width: 40px;
    height: 23px;
  }
  .TopicMbB4_dot1 {
    position: absolute;
    left: 99px;
    top: 70px;

    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbB4_dot2 {
    position: absolute;
    left: 125px;
    top: 70px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB4_dot3 {
    position: absolute;
    left: 170px;
    top: 70px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB4_dot4 {
    position: absolute;
    left: 194px;
    top: 70px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }
  .TopicMbB4_Video {
    position: absolute;
    left: 277px;
    top: 69px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB4_VideoYouKu {
    position: absolute;
    left: 12px;
    top: -21px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  .TopicMbB4_dotCard {
    position: absolute;
    left: 50px;
    top: 109px;
    animation: flicker 1s linear infinite;
    color: #535353;
  }

  // 分隔線

  .ellipsis_pro {
    font-size: 15px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .ellipsis_exh {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .logImgFrame_ExhInfo {
    width: 230px;
    min-height: 185px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .lowZindex {
    z-index: 1999;
  }

  .iconOpenHover {
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }

  // 置底

  .Mbfooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #82808059;
    color: #fff;
    height: 170px;
    border-top: 1px solid #b7b4b4;

    background-image: url('../../assets/images/booth_icon_bg.jpg');
    background-size: cover;
    background-position: center center;
    z-index: 1;
  }

  .userOnline {
    position: relative;
  }

  @media (max-width: 550px) {
    .unreadFrame {
      position: relative;
    }

    .mesbadge {
      position: absolute;
      top: 25px;
      right: 25px;
      font-size: 11px;
      background-color: #e0492e;
      color: #fff;
    }

    .sideMenu {
      label {
        box-shadow: 5px 0 5px rgba(23, 23, 54, 0.6);
        width: 32px;
        height: 210px;
        background-color: #2f63c2d6;
        color: #ffffff;
        position: absolute;
        left: -35px;
        top: -175px;
        margin: auto;
        line-height: 33px;
        text-align: center;
        border-radius: 5px 0 0 5px;
        writing-mode: vertical-lr;
        cursor: pointer;
      }
    }
  }

  .mobile {
    right: 0;
    width: 100%;
    height: 100%;
  }

  .minimal {
    width: 0;
    height: 0;
  }

  #myDIV {
    z-index: 4002;
  }

  .Chatbox {
    position: fixed;
    bottom: 0px;
    right: 0px;
    width: 900px;
    height: 590px;
    z-index: 4000;
  }

  .disable-pull {
    position: fixed;
    top: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: hidden;
  }

  .mobile {
    right: 0;
    width: 100%;
    height: 100%;
  }

  .minimal {
    width: 0;
    height: 0;
  }

  .tooltip {
    z-index: 100000000;
  }

  .topUK {
    position: relative;
  }

  .UKframe {
    position: absolute;
    top: 0;
    right: 0;
    /* background-color: #b8bdbf78; */
    width: 100%;
    height: 95%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .insideUK {
    position: absolute;
    top: 0;
    right: 0;
    /* background-color: rgba(52, 152, 177, 0.712); */
    width: 100%;
    height: 95%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #5e5e5ecc;
  }

  .alert {
    padding: 0.15rem 1.25rem;
  }
</style>
